import { Container } from 'unstated'
import date from 'date-and-time'
import { resetState } from '../../../Helpers/Misc'

const initialState = () => ({
  loading: true,
  paramName: '',
  courseID: '',
  notes: [],
})

export default class NotesStore extends Container {
  name = 'NotesStore'

  state = initialState()

  initTeacherNotes = async (chapters, courseID) => {
    await this.setState({
      ...resetState(this.state, initialState()),
      paramName: 'lessonNote',
    })

    const notes = chapters
      .map((chapter, chapterIndex) =>
        chapter.lessons.map((lesson, lessonIndex) => ({
          note: lesson.lessonNote,
          updateUrl: `/courses/${courseID}/chapters/${chapter.id}/lessons/${lesson.id}/notes`,
          noteTitle: {
            title: chapter.title || `Chapter ${chapterIndex + 1}`,
            subTitle: lesson.title || `Lesson ${lessonIndex + 1}`,
          },
        })),
      )
      .reduce((merged, current) => [...merged, ...current], [])

    await this.setState({
      notes,
      loading: false,
    })
  }

  initStudentNotes = async (enrollment) => {
    await this.setState({
      ...resetState(this.state, initialState()),
      paramName: 'studentClassNote',
    })

    const classes = enrollment.classes

    const notes = Object.keys(classes).map((key, index, arr) => ({
      note: classes[key].studentClassNote,
      updateUrl: `/course-registrations/${enrollment.id}/classes/class_${index}/notes`,
      noteTitle: {
        title: `${date.format(
          new Date(classes[key].startTime),
          `DD-MM-YYYY`,
        )} (Class ${index < 9 ? '0' + (index + 1) : index + 1} of ${
          arr.length
        })`,
      },
    }))

    await this.setState({
      notes,
      loading: false,
    })
  }

  updateNote = (index, value) => {
    const { notes } = this.state

    notes[index] = {
      ...notes[index],
      note: value,
    }

    this.setState({ notes })
  }
}
